import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Divider,
  FlexboxGrid,
  IconButton,
  Input,
  InputGroup,
  Loader,
  Message,
  Modal,
  Pagination,
  Panel,
  SelectPicker,
  Stack,
  Table,
  toaster,
  Tooltip,
  Whisper
} from 'rsuite';
import NavD from './NavD';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';
import SearchIcon from '@rsuite/icons/Search';
import VisibleIcon from '@rsuite/icons/Visible';
import globalIP from '@/GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import EditIcon from '@rsuite/icons/Edit';
import MoreIcon from '@rsuite/icons/More';
import EmailIcon from '@rsuite/icons/Email';
import imger from '../../assets/images/items/whatsapp.svg';
import TrashIcon from '@rsuite/icons/Trash';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import { Dropdown } from 'antd';
import { EyeFilled } from '@ant-design/icons';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const { Column, HeaderCell, Cell } = Table;
const Library = ({ activeKey, handleNavSelect, label }) => {
  const [cataloguedata, setCatalogueData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageedit, setPageEdit] = useState(1);
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [meta123, setMeta123] = useState<MetaData>();
  const [metaedit, setMetaEdit] = useState<MetaData>();
  const [productData, setProductData] = useState([]);
  const [selectedOption, setSelectedOption] = useState('Trash');
  const [selectedBuyerName, setSelectedBuyerName] = useState('');
  const [selectedBuyerCompName, setSelectedBuyerCompName] = useState('');
  const [cataname, setCataname] = useState('');
  const [productalldata, setProductAlldata] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fetchProducts1, setFetchedProducts] = useState([]);
  const [pageview, setPageView] = useState(1);
  const [metaview, setMetaView] = useState<MetaData>();
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    fetchData();
  }, [page, pageedit, selectedOption]);

  // let setSearchQryBtn = false;
  const [searchQuery, setSearchQuery] = useState('');



  const [debouncedSearchQueryorg, setDebouncedSearchQueryorg] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQueryorg(searchQuery.trim());
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    setFilteredData([])
    setPage(1)
    fetchData()

  }, [debouncedSearchQueryorg]); // This effect now triggers when debouncedSearchQuery changes


  useEffect(() => {

    setSearchQuery('')
    fetchData();
    setPage(1);

  }, [selectedBuyerName, selectedBuyerCompName]);

  const [searchQuery1, setSearchQuery1] = useState('');
  const handleSearch1 = value => {
    setSearchQuery1(value);
  }
  const fetchData = async () => {
    setProgress(30);
    setIsLoading(true);

    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim()
      const searchQry = `filters[$or][0][CollectionName][$containsi]=${searchQryy}&filters[$or][1][BuyerCompany][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
      setPage(1)
    }
    const buyerNameFilter =
      selectedBuyerName?.length > 0
        ? `&filters[BuyerName][$eq]=${encodeURIComponent(selectedBuyerName)}`
        : '';
    const buyerCompanyNameFilter =
      selectedBuyerCompName?.length > 0
        ? `&filters[BuyerCompany][$eq]=${encodeURIComponent(selectedBuyerCompName)}`
        : '';
    let response;
    // if (selectedOption == 'Trash') {
    //   response = await fetch(
    //     `${globalIP}/api/collections?populate=*&pagination[page]=${page}&filters[Status][$ne]=Trash&sort[0]=id:desc`
    //   );
    // } else {
    //   response = await fetch(
    //     `${globalIP}/api/collections?populate=*&pagination[page]=${page}&filters[Status][$eq]=${selectedOption}&sort[0]=id:desc`
    //   );
    // }
    if (selectedOption == 'Trash') {
      // console.log(`${globalIP}/api/collections?populate=*&pagination[page]=${page}&filters[Status][$ne]=Trash&sort[0]=id:desc${buyerNameFilter}${searchQryFilter}`)
      response = await fetch(
        `${globalIP}/api/collections?populate=*&pagination[page]=${page}&filters[Status][$ne]=Trash&sort[0]=id:desc${buyerNameFilter}${buyerCompanyNameFilter}${searchQryFilter}`
      );
    } else {
      // console.log(`${globalIP}/api/collections?populate=*&pagination[page]=${page}&sort[0]=id:desc${buyerNameFilter}${searchQryFilter}`)

      response = await fetch(
        `${globalIP}/api/collections?populate=*&pagination[page]=${page}&sort[0]=id:desc${buyerNameFilter}${buyerCompanyNameFilter}${searchQryFilter}`
      );
    }
    setProgress(60);
    const json = await response.json();
    setMeta123(json.meta);
    setIsLoading(false);
    setProgress(100);
    setIsLoading1(true);

    let searchFilter = '';
    if (searchQuery1.length > 0) {
      let searchQryy = searchQuery1.trim();
      const searchQry1 = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][FinishName][$containsi]=${searchQryy}&filters[$or][3][ColorName][$containsi]=${searchQryy}&filters[$or][4][Description][$containsi]=${searchQryy}`;
      searchFilter = `&${searchQry1}`;
    }

    const productResponse = await fetch(
      `${globalIP}/api/products?populate=*&sort[0]=id:desc&filters[Authorized][$eq]=Authorised&pagination[page]=${pageedit}${searchFilter}`
    );
    const productJson = await productResponse.json();
    setMetaEdit(productJson.meta);
    setProductData(productJson.data);
    console.log("JSON DATA :", json.data)
    const updatedCatalogueData = json.data.map(item => ({
      ...item,
      itemCount: item.attributes.CollectionProduct.length
    }));
    setFilteredData(updatedCatalogueData)
    setCatalogueData(updatedCatalogueData);
    setIsLoading1(false);
  };

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery1);

  // Debounce effect for searchQuery1
  useEffect(() => {
    // setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery1);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery1 changes before the delay
  }, [searchQuery1]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setPage(1);
    fetchData(); // Your data fetching function
  }, [debouncedSearchQuery]);

  const handleChangeLimitEdit = () => {
    setPageEdit(1);
  };
  const handleChangeLimit = () => {
    setPage(1);
  };
  const handleChangeLimitforviw = () => {
    setPageView(1);
  };

  const [isStatusPickerVisible, setStatusPickerVisible] = useState({});
  const toggleStatusPicker = rowId => {
    setStatusPickerVisible(prevState => ({
      ...prevState,
      [rowId]: !prevState[rowId]
    }));
  };

  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'inActive', label: 'Inactive' }
  ];

  const handleStatusChange = async (catalogId, newStatus) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...cataloguedata,
        Status: newStatus
      })
    );

    fetch(`${globalIP}/api/collections/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        fetchData();
        // fetchDatat();
      })
      .catch(error => {
        console.error(error);
      });
    setStatusPickerVisible(false);
  };

  function getStatusButtonClass(status) {
    if (status === 'inActive') {
      return 'inactive-button';
    } else if (status === 'Active') {
      return 'active-button';
    } else if (status === 'Draft') {
      return 'draft-button';
    }
  }

  const handleMoreIconClick = async rowData => {
    const catalogueProducts = rowData.attributes.CollectionProduct.map(
      product => product.ColProduct
    );
    setCataname(rowData.attributes.CollectionName);
    const matchingIds = catalogueProducts.map(catalogProduct => catalogProduct);
    const pageIds = matchingIds.map(id => parseInt(id, 10));
    setProductAlldata(pageIds);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (productalldata.length) {
      fetchProducts(productalldata);
    }
  }, [productalldata, pageview]);
  const fetchProducts = async matchingIds => {
    try {
      const productIdsQueryParam = matchingIds.map(id => `filters[id][$in][]=${id}`).join('&');
      const response = await fetch(
        `${globalIP}/api/products?${productIdsQueryParam}&populate=*&sort[0]=id:desc&pagination[page]=${pageview}`
      );
      const responsevar = await fetch(
        `${globalIP}/api/variant-products?${productIdsQueryParam}&populate=*`
      );
      const json = await response.json();
      const jsonvar = await responsevar.json();
      const newPdata = [...json.data, ...jsonvar.data];
      setMetaView(json.meta);
      setFetchedProducts(newPdata);
      setCurrentPage(pageview);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const CustomCell = CompactCell;
  const CustomHeaderCell = CompactHeaderCell;
  const [finShow, setFinShow] = useState(false);

  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details`);
      const json = await response.json();
      setFinShow(json.data[0].attributes.setFinish);

      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [vardata, setVarData] = useState([]);
  const fetchDataVData = async id => {
    try {
      const response = await fetch(
        `${globalIP}/api/variant-products?filters[Variant_Id][$eq]=${id}&populate=*`
      );
      const json = await response.json();
      setVarData(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [varOpen, setVarOpen] = useState(false);
  const openVardata = id => {
    setVarOpen(true);
    fetchDataVData(id);
  };
  const [showDimm, setShowDimm] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleOpenDimm = (row) => {
    setSelectedRow(row);
    console.log('ROW :', row)
    setShowDimm(true);
  }
  const handleCloseDimm = () => setShowDimm(false);

  const columns = [
    {
      key: 'ProductId',
      label: 'Assign',
      width: 100,
      fixed: true,
      headerCell: (
        <Table.HeaderCell>
          <b>Assign</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => (
            <Checkbox
              checked={editedProducts?.map(item => item.ColProduct).includes(String(rowData.id))}
              onChange={() => handleProductToggle(rowData)}
            />
          )}
        </Cell>
      )
    },
    {
      key: 'Image',
      label: 'Image',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }}>
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 400, objectFit: 'contain' }} />
              </Tooltip>
            );

            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${globalIP}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`
                )}
              >
                <img
                  src={`${globalIP}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-12px', objectFit: 'contain' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductId}</Cell>
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.Description}</Cell>
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductName}</Cell>
    },
    {
      key: sizeshow ? 'SizeRange' : 'Dimension',
      label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'Dimension',
      width: 200,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{sizeshow ? label[0]?.attributes.SizeRange : 'Dimension'}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const { Length, Width, Height, SizeUnit, SetStatus, SetSizes } = rowData.attributes;
            if (SetStatus === 'Set' && Array.isArray(SetSizes)) {
              return <Button active onClick={() => handleOpenDimm(rowData.attributes.SetSizes)}>View Size</Button>
            }
            else {
              return `${Length} x ${Width} x ${Height} ${SizeUnit}`
            }
          }}
        </Cell>
      )
    },
    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 120,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.FinishName}</Cell>
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 120,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ColorName}</Cell>
    },
    {
      key: 'Action',
      label: `Action`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            rowData.attributes.Variant === true ? (
              <>
                <Button
                  appearance="ghost"
                  color="cyan"
                  onClick={() => openVardata(rowData.attributes.ProductCode)}
                >
                  Variant
                </Button>
              </>
            ) : (
              <>
                <p>-</p>
              </>
            )
          }
        </Cell>
      )
    }
  ];
  const [columnKeys, setColumnKeys] = useState(columns.map(column => column.key));
  useEffect(() => {
    setColumnKeys(previousKeys => {
      if (sizeshow) {
        return [...previousKeys, 'SizeRange'];
      } else {
        return previousKeys.filter(key => key !== 'SizeRange');
      }
    });
  }, [sizeshow]);
  ;

  const [editingCollection, setEditingCollection] = useState(null);
  const [editedProducts, setEditedProducts] = useState([]);
  const [isModalOpenp, setIsModalOpenp] = useState(false);
  const [loadingadd, setLoadingAdd] = useState(false);

  useEffect(() => {
    console.log('editedProducts', editedProducts);
  }, [editedProducts])

  const handleEdit = collection => {
    setEditingCollection(collection);
    setIsModalOpenp(true);
    setEditedProducts(collection.attributes.CollectionProduct);
  };

  const handleSave = async collection => {
    if (editedProducts.length === 0) {
      toaster.push(
        <Message showIcon type="warning">
          Please select at least one product.
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      try {
        setLoadingAdd(true);
        const response = await fetch(`${globalIP}/api/collections/${collection.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ data: { CollectionProduct: editedProducts } })
        });

        if (response.ok) {
          fetchData();
          setLoadingAdd(false);
          setEditingCollection(null);
          setEditedProducts([]);
        } else {
          const errorResponse = await response.json();
          console.error('Error saving collection:', errorResponse);
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
      setIsModalOpen(false);
    }
  };
  const handleCancel = () => {
    setEditingCollection(null);
    setEditedProducts([]);
    setIsModalOpen(false);
  };
  const [isAnyCheckboxSelected, setIsAnyCheckboxSelected] = useState(true);
  const handleCheckboxChange = (rowId, checked) => {
    setEditedProducts(prevProducts => {
      if (checked) {
        const product = vardata.find(item => item.id == rowId);
        if (product) {
          return [
            ...prevProducts,
            {
              ColProduct: String(product.id),
              CatalogCode: editingCollection.attributes.CollectionCode
            }
          ];
        } else {
          console.warn('Product not found in vardata for ID:', rowId);
        }
      } else {
        console.log('Removing product with ID:', rowId);
        return prevProducts.filter(product => product.ColProduct !== String(rowId));
      }
      return prevProducts;
    });
  };

  const handleProductToggle = productId => {
    setEditedProducts(prevProducts => {
      const isProductIncluded = editedProducts.some(
        item => item.ColProduct == String(productId.id)
      );

      let updatedProducts;
      if (isProductIncluded) {
        updatedProducts = prevProducts.filter(item => item.ColProduct != String(productId.id));
      } else {
        updatedProducts = [
          ...prevProducts,
          {
            ColProduct: String(productId.id),
            CatalogCode: editingCollection.attributes.CollectionCode
          }
        ];
      }

      setIsAnyCheckboxSelected(updatedProducts.length > 0);
      return updatedProducts;
    });
  };
  const handleCheckAllT = checked => {
    if (!checked) {
      // Add products to editedProducts that are not already present
      const newProducts = vardata
        .map(product => ({
          ColProduct: String(product.id),
          CatalogCode: editingCollection.attributes.CollectionCode
        }))
        .filter(
          newProduct =>
            !editedProducts.some(
              existingProduct => existingProduct.ColProduct === String(newProduct.ColProduct)
            )
        );
      setEditedProducts(prevState => [...prevState, ...newProducts]);
    }
    if (checked) {
      setEditedProducts(prevState =>
        prevState.filter(
          product =>
            !vardata.some(row => {
              console.log('`${row.id} ${product.CatalogProduct}`');
              console.log(`${row.id} ${product.ColProduct}`);

              return row.id === parseInt(product.ColProduct);
            })
        )
      );
    }
  };

  const [opendelete, setOpendelete] = useState(false);
  const handleClosedelete = () => setOpendelete(false);
  const [isRobotChecked2, setIsRobotChecked2] = useState(false);
  const [loadelete, setLoadelete] = useState(false);
  const [collid, setCollid] = useState(null);
  const alertdelete = rowId => {
    setOpendelete(true);
    setCollid(rowId);
  };
  const deletecoll = async () => {
    try {
      setLoadelete(true);
      const response = await fetch(`${globalIP}/api/collections/${collid}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        fetchData();
        setLoadelete(false);
        setOpendelete(false);
      } else {
        const errorResponse = await response.json();
        console.error('Error Delete collection:', errorResponse);
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };
  const handleSearch = value => {
    setSearchQuery(value);
  };
  const [buyeerdata, setBuyeerdata] = useState([]);
  const [buyeerCompNamedata, setBuyeerCompNamedata] = useState([]);
  const [allBuyerData, setAllBuyerData] = useState([]);

  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${globalIP}/api/buyer-details`);
      const json = await response.json();
      const data = json.data ?? [];

      setAllBuyerData(data);

      const uniqueCompanyNames = Array.from(
        new Set(data.map(item => item.attributes.companynm?.trim() || ''))
      );

      const processedBuyerCompanyNameData = uniqueCompanyNames.map(companyName => ({
        label: companyName,
        value: companyName
      }));

      setBuyeerCompNamedata(processedBuyerCompanyNameData);

      const initialFiltered = selectedBuyerCompName
        ? data.filter(
          item =>
            item.attributes.companynm?.trim().toLowerCase() ===
            selectedBuyerCompName.trim().toLowerCase()
        )
        : data;

      const processedBuyerNameData = initialFiltered.map(item => ({
        label: item?.attributes?.buyernm || '',
        value: item?.attributes?.buyernm || '',
        company: item?.attributes?.companynm?.trim() || ''
      }));

      setBuyeerdata(processedBuyerNameData);

    } catch (error) {
      console.error('Error fetching buyer data:', error);
    }
  };
  useEffect(() => {
    if (!allBuyerData || allBuyerData.length === 0) return;

    const filtered = selectedBuyerCompName
      ? allBuyerData.filter(
        item =>
          item.attributes.companynm?.trim().toLowerCase() ===
          selectedBuyerCompName.trim().toLowerCase()
      )
      : allBuyerData;

    const processed = filtered.map(item => ({
      label: item?.attributes?.buyernm || '',
      value: item?.attributes?.buyernm || '',
      company: item?.attributes?.companynm?.trim() || ''
    }));

    setBuyeerdata(processed);
  }, [selectedBuyerCompName, allBuyerData]);
  const [filteredData, setFilteredData] = useState([]);

  // useEffect(() => {
  //   const filterData = cataloguedata.filter(item => {
  //     const CollectionName = item.attributes?.CollectionName?.toLowerCase();
  //     const BuyerCompany = item.attributes?.BuyerCompany?.toLowerCase();
  //     const buyer = item.attributes?.BuyerCompany;

  //     const buyerNameMatch = !selectedBuyerName || selectedBuyerName.includes(buyer);
  //     return (
  //       (CollectionName?.includes(searchQuery.toLowerCase()) ||
  //         BuyerCompany?.includes(searchQuery.toLowerCase())) &&
  //       buyerNameMatch
  //     );
  //   });
  //   setFilteredData(filterData);
  // }, [cataloguedata, selectedBuyerName, searchQuery]);

  const handleEscKey = event => {
    if (event.key === 'Escape') {
      setEditingCollection(null);
      setEditedProducts([]);
      setIsModalOpen(false);
    }
  };
  useEffect(() => {
    window.addEventListener('keydown', handleEscKey);
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, []);
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 290; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  const items = [
    { key: "content1", label: "Manage Collection" },
    { key: "content2", label: "Library" },
  ];
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <div
        style={{
          justifyContent: 'space-between',
          width: '-webkit-fill-available',
          position: 'fixed',
          height: '185px',
          background: '#fff',
          zIndex: 1
        }}
      >
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <Stack
                direction="row"
                alignItems="flex-start"
                spacing={132}
                style={{ marginTop: '10px' }}
              >
                {/* <NavD activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} /> */}
              </Stack>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Manage Collection</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={10}>
              <Stack direction="column" alignItems="flex-start">
                <label>Buyer Company</label>
                <SelectPicker
                  data={buyeerCompNamedata}
                  onChange={value => {
                    setSelectedBuyerCompName(value);
                    setPage(1);
                    setSearchQuery('')
                  }}
                  onClean={() => {
                    setSelectedBuyerCompName('');
                  }}
                  size="md"
                  appearance="default"
                  placeholder={"Buyer Company"}
                  style={{ width: 200 }}
                />
              </Stack>
              <Stack direction="column" alignItems="flex-start">
                <label>{`${label[0]?.attributes.BuyerName}`}</label>
                <SelectPicker
                  data={buyeerdata}
                  onChange={value => {
                    setSelectedBuyerName(value);
                    setPage(1);
                    setSearchQuery('')
                  }}
                  onClean={() => {
                    setSelectedBuyerName('');
                  }}
                  size="md"
                  appearance="default"
                  placeholder={`${label[0]?.attributes.BuyerName}`}
                  style={{ width: 200 }}
                />
              </Stack>
              <Stack direction="column" alignItems="flex-start">
                <label style={{ visibility: "hidden" }}>Search</label>
                <InputGroup inside>
                  <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={value => {
                      setSearchQuery(value);
                    }}
                    className="pdt-srch"
                  />
                  <InputGroup.Addon>
                    <SearchIcon style={{ cursor: 'pointer' }} />
                  </InputGroup.Addon>
                </InputGroup>
              </Stack>
              <Stack direction="column" alignItems="flex-start">
                    <label style={{visibility:"hidden"}}>.</label>
                <Dropdown
                  menu={{
                    items,
                    onClick: ({ key }) => handleNavSelect(key),
                  }}
                  trigger={["click"]}
                >
                  <Button>
                    View <EyeFilled />
                  </Button>
                </Dropdown>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
      </div>
      <Panel style={{ marginTop: '190px' }}>
        <Table
          height={tableHeight}
          className="mange-tbl"
          data={filteredData}
          loading={isLoading1}
          bordered
          cellBordered
          wordWrap="break-word"
        >
          <Table.Column width={80} align="center" fixed>
            <HeaderCell>
              <b>Sr. No.</b>
            </HeaderCell>
            <Cell>{(_, rowIndex) => (page - 1) * 25 + rowIndex + 1}</Cell>
          </Table.Column>

          <Column width={300} align="center">
            <HeaderCell>
              <b>Collection Name</b>
            </HeaderCell>
            <Cell>
              {rowData => (
                <>
                  <div style={{ display: 'grid' }}>
                    {rowData.attributes.CollectionName}

                    {rowData.id === editingCollection?.id ? (
                      <div>
                        <Modal
                          size="full"
                          open={isModalOpenp}
                          onClose={() => setIsModalOpenp(false)}
                          backdrop="static"
                          className="modal"
                        >
                          <FlexboxGrid justify="space-between">
                            <FlexboxGrid.Item colspan={6}>
                              <b>Add/Remove Products</b>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item colspan={6}>
                              <InputGroup inside>
                                <Input
                                  placeholder="Search"
                                  type="text"
                                  value={searchQuery1}
                                  onChange={value => handleSearch1(value)}
                                />
                                <InputGroup.Addon>
                                  <SearchIcon />
                                </InputGroup.Addon>
                              </InputGroup>
                            </FlexboxGrid.Item>
                          </FlexboxGrid>
                          <Modal.Body>
                            {isLoading1 ? (
                              <Loader size="sm" speed="fast" center content="Loading..." />
                            ) : (
                              <>
                                <Table
                                  data={productData}
                                  //   .filter(item => {
                                  //   const ProductName = item.attributes.ProductName
                                  //     ? item.attributes.ProductName.toLowerCase()
                                  //     : '';
                                  //   const AliasCode = item.attributes.ProductId
                                  //     ? item.attributes.ProductId.toLowerCase()
                                  //     : '';
                                  //   const ColorName = item.attributes.ColorName
                                  //     ? item.attributes.ColorName.toLowerCase()
                                  //     : '';
                                  //   const FinishName = item.attributes.FinishName
                                  //     ? item.attributes.FinishName.toLowerCase()
                                  //     : '';

                                  //   return (
                                  //     ProductName.includes(searchQuery1.toLowerCase()) ||
                                  //     AliasCode.includes(searchQuery1.toLowerCase()) ||
                                  //     ColorName.includes(searchQuery1.toLowerCase()) ||
                                  //     FinishName.includes(searchQuery1.toLowerCase())
                                  //   );
                                  // })

                                  height={tableHeight}
                                  wordWrap
                                  rowKey="id"
                                  cellBordered
                                  bordered
                                >
                                  {columns.map(column => {
                                    if (columnKeys.includes(column.key)) {
                                      const { key, label, headerCell, cell, ...rest } = column;
                                      return (
                                        <Table.Column {...rest} key={key} align="center">
                                          {headerCell || (
                                            <CustomHeaderCell>{label}</CustomHeaderCell>
                                          )}
                                          {cell || <CustomCell dataKey={key} />}
                                        </Table.Column>
                                      );
                                    }
                                    return null;
                                  })}
                                </Table>
                                <div style={{ padding: 20 }}>
                                  <Pagination
                                    prev
                                    next
                                    first
                                    last
                                    ellipsis
                                    boundaryLinks
                                    maxButtons={5}
                                    limit={25}
                                    size="xs"
                                    layout={['total', '-', 'pager', 'skip']}
                                    total={metaedit?.pagination?.total || 0}
                                    activePage={pageedit}
                                    onChangePage={setPageEdit}
                                    onChangeLimit={handleChangeLimitEdit}
                                  />
                                </div>
                              </>
                            )}
                          </Modal.Body>
                          <Modal.Footer>
                            <Button appearance="subtle" active onClick={handleCancel}>
                              Cancel
                            </Button>
                            <Button
                              onClick={() => handleSave(editingCollection)}
                              appearance="primary"
                              color="cyan"
                              // disabled={!isAnyCheckboxSelected}
                              loading={loadingadd}
                            >
                              Save
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </div>
                    ) : (
                      <span style={{ fontSize: '12px', color: 'gray' }}>
                        {rowData.itemCount} Products
                      </span>
                    )}
                  </div>
                </>
              )}
            </Cell>
          </Column>
          <Column width={200} align="center">
            <HeaderCell>
              <b>Buyer Company</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                rowData.attributes?.BuyerCompany
                  ? rowData.attributes.BuyerCompany
                  : rowData.attributes?.CPerson
              }
            </Cell>
          </Column>
          <Column width={200} align="center">
            <HeaderCell>
              <b>{`${label[0]?.attributes.BuyerName}`}</b>
            </HeaderCell>
            <Cell>
              {rowData =>
                rowData.attributes?.BuyerName
                  ? rowData.attributes.BuyerName
                  : rowData.attributes?.CPerson
              }
            </Cell>
          </Column>
          <Column width={60} align="center">
            <HeaderCell>
              <b>View</b>
            </HeaderCell>
            <Cell>
              {rowData => (
                <>
                  <Whisper
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>View Products</Tooltip>}
                  >
                    <IconButton
                      size="xs"
                      icon={<VisibleIcon />}
                      active
                      onClick={() => handleMoreIconClick(rowData)}
                      style={{ marginRight: '10px' }}
                    />
                  </Whisper>
                </>
              )}
            </Cell>
          </Column>
          <Column width={100} align="center">
            <HeaderCell>
              <b>Status</b>
            </HeaderCell>
            <Cell dataKey={'attributes.Status'}>
              {rowData => (
                <Button
                  className={getStatusButtonClass(rowData.attributes.Status)}
                  style={{ width: 'auto' }}
                  size='sm'
                >
                  {rowData.attributes.Status}
                </Button>
              )}
            </Cell>
          </Column>
          <Column width={280} align="left" flexGrow={1}>
            <HeaderCell>
              <b>Action</b>
            </HeaderCell>
            <Table.Cell>
              {rowData => {
                return (
                  <>
                    {/* {rowData.attributes.Status === 'Active' && (
                            <Whisper followCursor speaker={<Tooltip>Download</Tooltip>}>
                              <Link
                                to={{
                                  pathname: `/${ugr}/generate-catalogue1`,
                                  search: `?id=${rowData.id}&cataloguename=${rowData.attributes.catalogueName}`
                                }}
                              >
                                <IconButton
                                  size="xs"
                                  icon={<SortDownIcon />}
                                  active
                                  style={{ marginRight: '10px' }}
                                />
                              </Link>
                            </Whisper>
                          )} */}
                    {!editingCollection || rowData.id !== editingCollection.id ? (
                      <Whisper followCursor speaker={<Tooltip>Add/Remove Products</Tooltip>}>
                        <IconButton
                          style={{ marginRight: '10px' }}
                          icon={<EditIcon />}
                          size="xs"
                          active
                          onClick={() => handleEdit(rowData)}
                        />
                      </Whisper>
                    ) : (
                      <>
                        <IconButton
                          style={{ marginTop: '10px', opacity: !isAnyCheckboxSelected ? '0.8' : '1' }}
                          size="xs"
                          icon={<CheckIcon />}
                          active
                          onClick={() => handleSave(rowData)}
                          disabled={!isAnyCheckboxSelected}
                        />

                        <IconButton
                          style={{ marginRight: '10px' }}
                          size="xs"
                          icon={<CloseIcon />}
                          active
                          onClick={() => handleCancel()}
                        />
                      </>
                    )}
                    <Whisper followCursor speaker={<Tooltip>Active/Inactive</Tooltip>}>
                      <IconButton
                        size="xs"
                        icon={<MoreIcon />}
                        active
                        style={{ marginRight: '10px' }}
                        onClick={() => toggleStatusPicker(rowData.id)}
                      />
                    </Whisper>
                    {isStatusPickerVisible[rowData.id] && ( // Render SelectPicker if isVisible is true
                      <SelectPicker
                        data={statusOptions}
                        value={rowData.attributes.Status}
                        searchable={false}
                        onChange={newStatus => handleStatusChange(rowData.id, newStatus)}
                        style={{ width: 120, marginTop: '-8px', marginRight: '10px' }}
                        cleanable={false}
                        placement="auto"
                        size="md"
                      />
                    )}
                    <Whisper followCursor speaker={<Tooltip>Delete</Tooltip>}>
                      <IconButton
                        size="xs"
                        icon={<TrashIcon />}
                        active
                        style={{ marginRight: '10px' }}
                        onClick={() => alertdelete(rowData.id)}
                      />
                    </Whisper>
                  </>
                );
              }}
            </Table.Cell>
          </Column>
        </Table>
        <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            limit={25}
            size="xs"
            layout={['total', '-', 'pager', 'skip']}
            total={meta123?.pagination?.total || 0}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
        <Modal size="full" open={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <Modal.Header>
            <Stack>
              <b>Collection Name :</b>
              <p style={{ marginLeft: '8px' }}>{`${cataname}`}</p>
            </Stack>
          </Modal.Header>
          <Modal.Body>
            <Table
              data={fetchProducts1}
              height={tableHeight}
              rowKey="id"
              cellBordered
              rowHeight={60}
              wordWrap="break-word"
              bordered
            >
              <Table.Column width={80} align="center" fixed>
                <HeaderCell>
                  <b>Sr. No.</b>
                </HeaderCell>
                <Cell>{(_, rowIndex) => (currentPage - 1) * 25 + rowIndex + 1}</Cell>
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>Image</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {rowData => {
                    const renderTooltip = imageSrc => (
                      <Tooltip style={{ backgroundColor: 'white' }}>
                        <img
                          src={imageSrc}
                          alt="Product Image"
                          style={{ width: 400, height: 400, objectFit: 'contain' }}
                        />
                      </Tooltip>
                    );

                    return (
                      <Whisper
                        followCursor
                        trigger="hover"
                        placement="right"
                        speaker={renderTooltip(
                          `${globalIP}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`
                        )}
                      >
                        <img
                          src={`${globalIP}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                          alt="Product Image"
                          style={{ width: 50, height: 50, objectFit: 'contain' }}
                        />
                      </Whisper>
                    );
                  }}
                </Table.Cell>
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.AliasCode}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ProductId" />
              </Table.Column>
              <Table.Column width={250} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.Description}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.Description" />
              </Table.Column>
              <Table.Column width={250} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.ProductName}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ProductName" />
              </Table.Column>
              {sizeshow ? (
                <Table.Column width={100} align="center">
                  <Table.HeaderCell>
                    <b>{label[0]?.attributes.SizeRange}</b>
                  </Table.HeaderCell>
                  <Table.Cell dataKey="attributes.SizeRange" />
                </Table.Column>
              ) : (
                <Table.Column width={150} align="center">
                  <Table.HeaderCell>
                    <b>{label[0]?.attributes.Sizeunit}</b>
                  </Table.HeaderCell>
                  <Table.Cell>
                    {rowData => {
                      const { Length, Width, Height, SizeUnit, SetStatus, SetSizes } = rowData.attributes;
                      if (SetStatus === 'Set' && Array.isArray(SetSizes)) {
                        return <Button active onClick={() => handleOpenDimm(rowData.attributes.SetSizes)}>View Size</Button>
                      }
                      else {
                        return `${Length} x ${Width} x ${Height} ${SizeUnit}`
                      }
                    }}
                  </Table.Cell>
                </Table.Column>
              )}

              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.cbm}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.cbm" />
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.finish}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.FinishName" />
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.color}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ColorName" />
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.NetWgt}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.NetWeight" />
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.Category}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.CategoryName" />
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.ProductType}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ProductTypeName" />
              </Table.Column>
            </Table>
            <div style={{ padding: 20 }}>
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={5}
                limit={25}
                size="xs"
                layout={['-', 'pager', 'skip']}
                total={metaview?.pagination?.total || 1}
                activePage={pageview}
                onChangePage={setPageView}
                onChangeLimit={handleChangeLimitforviw}
              />
            </div>
          </Modal.Body>
        </Modal>
        <Modal open={varOpen} onClose={() => setVarOpen(false)} size="lg" backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Variants</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table height={250} data={vardata} bordered cellBordered>
              <Column width={50} align="center">
                <HeaderCell style={{ padding: 0 }}>
                  <div style={{ lineHeight: '40px' }}>
                    <Checkbox
                      inline
                      checked={vardata.every(item =>
                        editedProducts.some(product => product.ColProduct == item.id)
                      )}
                      indeterminate={
                        vardata.some(item =>
                          editedProducts.some(product => product.ColProduct == item.id)
                        ) &&
                        !vardata.every(item =>
                          editedProducts.some(product => product.ColProduct == item.id)
                        )
                      }
                      onChange={checked =>
                        handleCheckAllT(
                          vardata.every(item =>
                            editedProducts.some(product => product.ColProduct == item.id)
                          )
                        )
                      }
                    />
                  </div>
                </HeaderCell>
                <Cell>
                  {rowData => {
                    const isChecked = editedProducts
                      .map(item => item.ColProduct)
                      .includes(String(rowData.id));
                    return (
                      <Checkbox
                        checked={isChecked}
                        onChange={(rowId, checked) => handleCheckboxChange(rowData.id, checked)}
                      />
                    );
                  }}
                </Cell>
              </Column>
              <Column width={100} align="center">
                <HeaderCell>
                  <b>Image</b>
                </HeaderCell>
                <Table.Cell>
                  {rowData => {
                    // Define a function to show the enlarged image on hover
                    const renderTooltip = imageSrc => (
                      <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                        <img
                          src={imageSrc}
                          alt="Product Image"
                          style={{ width: 400, height: 'auto' }}
                        />
                      </Tooltip>
                    );
                    return (
                      <Whisper
                        trigger="hover"
                        placement="right"
                        speaker={renderTooltip(
                          `${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`
                        )}
                      >
                        <img
                          src={`${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`}
                          alt="Product Image"
                          style={{ width: 50, height: 50, marginTop: '-16px' }}
                        />
                      </Whisper>
                    );
                  }}
                </Table.Cell>
              </Column>
              <Column width={100} align="center">
                <HeaderCell>
                  <b>Alias Code</b>
                </HeaderCell>
                <Cell dataKey={'attributes.ProductId'} />
              </Column>
              <Column flexGrow={1} align="center" fullText>
                <HeaderCell>
                  <b>Description</b>
                </HeaderCell>
                <Cell dataKey={'attributes.Description'} />
              </Column>
              <Column width={200} align="center">
                <HeaderCell>
                  <b>Product Name</b>
                </HeaderCell>
                <Cell dataKey={'attributes.ProductName'} />
              </Column>
              <Column width={100} align="center">
                <HeaderCell>Finish</HeaderCell>
                <Cell dataKey={'attributes.FinishName'} />
              </Column>
              <Column width={80} align="center">
                <HeaderCell>Color</HeaderCell>
                <Cell dataKey={'attributes.ColorName'} />
              </Column>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setVarOpen(false)} appearance="primary" color="cyan">
              Confirm Selection
            </Button>
          </Modal.Footer>
        </Modal>
      </Panel>
      <Modal open={showDimm} onClose={handleCloseDimm} size="sm">
        <Modal.Header>
          <Modal.Title><b> Dimension</b> </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table data={selectedRow} height={400} style={{ width: '-webkit-fill-available' }} wordWrap bordered>
            <Table.Column width={150} >
              <HeaderCell>Part Desc.</HeaderCell>
              <Cell dataKey="Description" />
            </Table.Column>

            <Table.Column width={200} >
              <HeaderCell>Size</HeaderCell>
              <Cell>
                {rowData => {
                  return `${rowData.Length}x${rowData.Width}x${rowData.Height} ${rowData.SizeUnit}`;
                }}
              </Cell>
            </Table.Column>

            <Table.Column width={100} >
              <HeaderCell>{label[0]?.attributes.color}</HeaderCell>
              <Cell dataKey="ColorName" />
            </Table.Column>

            <Table.Column width={100} >
              <HeaderCell>{label[0]?.attributes.NetWgt}</HeaderCell>
              <Cell dataKey="NetWt" />
            </Table.Column>
            {finShow && (
              <>
                <Table.Column width={100} >
                  <HeaderCell>Finish</HeaderCell>
                  <Cell dataKey="FinishName" />
                </Table.Column>

                <Table.Column width={200} >
                  <HeaderCell>Mat. Name</HeaderCell>
                  <Cell dataKey="MatName" />
                </Table.Column>
              </>
            )}
          </Table>
        </Modal.Body>
      </Modal>
      <Modal open={opendelete} onClose={handleClosedelete}>
        <Modal.Header>
          <Modal.Title>
            <b>Delete Collection</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel bordered style={{ marginTop: '6px', backgroundColor: '#f3f3f3' }}>
            <Stack direction="column" alignItems="flex-start">
              <FormControlLabel>
                This Collection Will be Deleted Permanently and Cannot be Restore. Are you sure your
                want to Continue?
              </FormControlLabel>
              <Checkbox
                checked={isRobotChecked2}
                onChange={() => setIsRobotChecked2(!isRobotChecked2)}
              >
                I'm not a robot
              </Checkbox>
            </Stack>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClosedelete} appearance="subtle" active>
            Cancel
          </Button>
          <Button
            onClick={deletecoll}
            appearance="primary"
            disabled={!isRobotChecked2}
            color="cyan"
            loading={loadelete}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Library;
